import { CircularProgress, Table, TableBody, TableCell, TableCellProps, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { AxiosError } from "axios";

export type TableColumn = {
  name: JSX.Element | string,
  props?: TableCellProps
}

export function TableTemplate<T>(props: {
  columns: TableColumn[],
  dataRows?: T[],
  count?: number | null,
  rowRenderFunc: (row: T) => JSX.Element[],
  loading: boolean,
  error?: AxiosError<any, any> | null,
  page: number,
  onPageChange: (page: number) => void,
  rowsPerPage: number,
  onRowsPerPageChange: (rpp: number) => void,
}) {

  const nCol = props.columns.length;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            {props.columns.map((column, i) =>
              <TableCell key={i} {...column.props} sx={{ ...column.props?.sx || {}, fontWeight: 600 }}>{column.name}</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {!props.loading && props.dataRows && props.dataRows.map((row, i) =>
            <TableRow key={i}>{props.rowRenderFunc(row)}</TableRow>
          )}
          {!props.loading && props.dataRows && props.dataRows.length === 0 &&
            <TableRow>
              <TableCell colSpan={nCol} align="center">
                <Typography sx={{ color: 'text.secondary', fontStyle: 'italic' }}>(data not found)</Typography>
              </TableCell>
            </TableRow>
          }
          {props.loading &&
            <TableRow>
              <TableCell colSpan={nCol} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          }
          {props.error &&
            <TableRow>
              <TableCell colSpan={nCol} align="center">
                <Typography sx={{ color: 'error.main', fontStyle: 'italic' }}>(error)</Typography>
              </TableCell>
            </TableRow>
          }
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={nCol}
              count={props.count || 0}
              page={props.page}
              onPageChange={(_, page) => props.onPageChange(page)}
              rowsPerPage={props.rowsPerPage}
              onRowsPerPageChange={e => props.onRowsPerPageChange(parseInt(e.target.value))}
              showFirstButton
              showLastButton
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}
